(() => {
  const optimizeArticleImages = () => {
    document.querySelectorAll('.article--content img').forEach((image) => {
      const source = image.dataset.nhOriginalSrc || image.getAttribute('src');
      if (!source || image.dataset.nhResponsive === 'true') return;

      let sourceUrl;
      try {
        sourceUrl = new URL(source, window.location.href);
      } catch (_error) {
        return;
      }

      const isShopifyImage =
        sourceUrl.hostname === 'cdn.shopify.com' ||
        sourceUrl.hostname.endsWith('.shopifypreview.com') ||
        sourceUrl.pathname.includes('/cdn/shop/');

      if (!isShopifyImage) return;

      const declaredWidth = Number.parseInt(image.getAttribute('width'), 10);
      const displayWidth = Number.isFinite(declaredWidth)
        ? Math.min(Math.max(declaredWidth, 320), 1400)
        : 760;
      const maximumWidth = Math.max(displayWidth, 480);
      const candidateWidths = [320, 480, 640, 768, 960, 1200, 1400]
        .filter((width) => width <= maximumWidth);

      if (!candidateWidths.includes(maximumWidth)) {
        candidateWidths.push(maximumWidth);
      }

      const resizedUrl = (width) => {
        const url = new URL(sourceUrl.href);
        url.searchParams.set('width', String(width));
        return url.href;
      };

      image.loading = 'lazy';
      image.decoding = 'async';
      image.fetchPriority = 'low';
      image.sizes = `(max-width: 767px) calc(100vw - 32px), ${displayWidth}px`;
      image.srcset = candidateWidths
        .map((width) => `${resizedUrl(width)} ${width}w`)
        .join(', ');
      image.src = resizedUrl(maximumWidth);
      image.dataset.nhResponsive = 'true';
      delete image.dataset.nhOriginalSrc;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeArticleImages, { once: true });
  } else {
    optimizeArticleImages();
  }
})();
